import { render, staticRenderFns } from "./ModifyClientClassificationModal.vue?vue&type=template&id=3037e02b&"
import script from "./ModifyClientClassificationModal.vue?vue&type=script&lang=js&"
export * from "./ModifyClientClassificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports